var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-item",
    { class: { hovered: _vm.hovered } },
    [
      _c(
        "q-item-side",
        [
          _c(
            "q-item-tile",
            { attrs: { avatar: "" } },
            [
              _c("placeholder-avatar", {
                attrs: { initials: _vm.initials, height: "38px", width: "38px" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("q-item-main", [
        _c("div", { staticClass: "row items-center gutter-x-md q-pl-md" }, [
          _c("div", { staticClass: "col-md-4 col-6 blurred" }, [
            _c(
              "div",
              {
                staticClass: "q-item-label",
                class: { "text-italic": !_vm.invite.name }
              },
              [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
            ),
            _c("div", { staticClass: "q-item-sublabel" }, [
              _vm._v("\n          " + _vm._s(_vm.$t("invited")) + "\n        ")
            ])
          ]),
          _c("div", { staticClass: "col-4 gt-sm blurred" }, [
            _c("span", { staticClass: "text-faded" }, [
              _vm._v(_vm._s(_vm.invite.email))
            ])
          ]),
          _vm.user.isAdminOf(_vm.team)
            ? _c(
                "div",
                {
                  staticClass:
                    "col-md-4 col-6 text-right team-list-entry__controls"
                },
                [
                  _c(
                    "q-btn",
                    { attrs: { icon: "more_vert", flat: "", dense: "" } },
                    [
                      _c(
                        "q-popover",
                        {
                          on: {
                            show: function($event) {
                              _vm.hovered = true
                            },
                            hide: function($event) {
                              _vm.hovered = false
                            }
                          }
                        },
                        [
                          _c(
                            "q-list",
                            { attrs: { separator: "", link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    },
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:copy",
                                      value: _vm.tokenLink,
                                      expression: "tokenLink",
                                      arg: "copy"
                                    },
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:success",
                                      value: _vm.handleClipboardSuccess,
                                      expression: "handleClipboardSuccess",
                                      arg: "success"
                                    },
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:error",
                                      value: _vm.handleClipboardError,
                                      expression: "handleClipboardError",
                                      arg: "error"
                                    }
                                  ]
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: "content_copy" }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t("copy_link") }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleDeleteInvite($event)
                                    }
                                  }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: "delete" }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t("remove") }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }